import { render, staticRenderFns } from "./WxLink.vue?vue&type=template&id=893a9f32&"
import script from "./WxLink.vue?vue&type=script&lang=js&"
export * from "./WxLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports